// features/chat/channels.ts
// The per-tournament chat channels, plus the claim/handoff metadata that turns
// the request channels into a CS-ticket flow.
//
// Technical "App Support" is NO LONGER a per-tournament channel — it moved to a
// single global support line (see chatService: global support helpers).

export type ChatChannelId = 'floor' | 'scorekeeper' | 'headjudge';

export interface ChatChannelDef {
  id: ChatChannelId;
  label: string;
  /** Short hint shown in the channel list. */
  hint: string;
}

export const CHAT_CHANNELS: ChatChannelDef[] = [
  { id: 'floor', label: 'Floor team', hint: 'Everyone on the floor' },
  { id: 'scorekeeper', label: 'Reach a Scorekeeper', hint: 'Pings the Scorekeepers' },
  { id: 'headjudge', label: 'Reach a Head Judge', hint: 'Pings the Head Judges' },
];

export const CHAT_CHANNEL_IDS: ChatChannelId[] = CHAT_CHANNELS.map((c) => c.id);

// "Request" channels behave like support tickets: a responder must Join to
// participate, the first to join claims it, and claiming clears the alert for
// the other same-role responders. The floor channel is an open group chat with
// no claim/handoff.
export const REQUEST_CHANNEL_IDS: ChatChannelId[] = ['scorekeeper', 'headjudge'];

export function isRequestChannel(id: ChatChannelId): boolean {
  return REQUEST_CHANNEL_IDS.includes(id);
}

// The staff role each request channel pings / can be claimed by.
export const CHANNEL_RESPONDER_ROLE: Partial<Record<ChatChannelId, string>> = {
  scorekeeper: 'Scorekeeper',
  headjudge: 'Head Judge',
};

// Conversation lifecycle, shared by request channels and the global support
// line. Absent meta is treated as 'open'.
export type ConversationStatus = 'open' | 'claimed' | 'resolved';

export interface ConversationMeta {
  status?: ConversationStatus;
  claimedBy?: string;
  claimedByName?: string;
  claimedByRole?: string;
  claimedAt?: number;
  /** Request channels only: an admin has been pulled into the thread. */
  adminRequested?: boolean;
  adminRequestedAt?: number;
}
